import { Page } from '@app/components/page/Page';
import { AuditIcon } from '@app/modules/audit/components/AuditIcon';
import { useIntl } from 'react-intl';
import { ReportsListContainer } from './ReportListContainer';

export function ReportsListPage() {
  const { $t } = useIntl();
  const title = $t({
    id: 'audit.reportsList.title',
    defaultMessage: 'Reportes guardados',
  });

  return (
    <Page htmlTitle={title}>
      <Page.Header
        icon={<AuditIcon />}
        title={[
          $t({
            id: 'audit.title',
            defaultMessage: 'Auditoría',
          }),
          title,
        ]}
      />
      <ReportsListContainer />
    </Page>
  );
}
